import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ModuleAccessService } from './module-access.service';
import { OperationAccessService } from './operation-access.service';
import { OperationId, can } from './permission-keys';
import { requiresPermission } from '../../feature/permissions/models/Module';

export const resolveModuleIdForPath = (path: string): string | undefined => {
  if (!path) {
    return undefined;
  }

  return path.split('/')[0];
};

export const moduleAccessGuard: CanActivateFn = async (route) => {
  const moduleAccessService = inject(ModuleAccessService);
  const operationAccessService = inject(OperationAccessService);
  const router = inject(Router);

  const path = route.routeConfig?.path ?? '';
  const moduleId = resolveModuleIdForPath(path);

  if (!moduleId || moduleId === 'dashboard') {
    return true;
  }

  if (moduleId === 'permissions') {
    const isSuperAdmin = await moduleAccessService.isSuperAdmin();
    return isSuperAdmin || router.parseUrl('/error');
  }

  if (!requiresPermission(moduleId)) {
    return true;
  }

  const required = requiredOperations(path).map(operationId => can(moduleId, operationId));

  const allowed = await moduleAccessService.hasAccess(moduleId)
    && await operationAccessService.hasPermission(required, 'all');
  return allowed || router.parseUrl('/error');
};

const requiredOperations = (path: string): OperationId[] =>
  path === 'new' || path.endsWith('/new') ? ['view', 'create'] : ['view'];
